<div class="o-grid u-hidden@up-to-md" *ngIf="vm.description && !vm.descriptionDisabled">
	<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-67@md-and-up">
		<p class="c-text u-osb-lg">{{vm.description.description}}</p>
	</div>
</div>
<div class="o-grid o-grid--wrap" style="min-height:300px">
	<ng-container *ngIf="vm.services?.length">
		<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up o-grid__cell--w-33@lg-and-up c-cell c-cell--isolated" *ngFor="let service of vm.services">
			<card-service [service]="service" [therapyTranslations]="vm.therapyTranslations"></card-service>
		</div>
	</ng-container>
	<div class="o-grid__cell o-grid__cell--w-100" *ngIf="vm.loading">
		<loader-overlay [theme]="1" *ngIf="vm.isInitial"></loader-overlay>
		<div class="c-loader" *ngIf="!vm.isInitial"></div>
	</div>
	<div class="o-grid__cell o-grid__cell--w-100" *ngIf="!vm.isLast && !vm.loading && vm.services?.length">
		<div class="o-grid o-grid--center-h">
			<div class="o-grid__cell o-grid__cell--w-fixed u-ost-lg u-osb-lg">
				<a id="showMoreServiceProvidersButton" href="javascript:void(0)" (click)="vm.searchDoctors(false)">{{ 'Services.Button.ShowMore' | translate }}</a>
			</div>
		</div>
	</div>
	<div class="o-grid__cell o-grid__cell--w-100" *ngIf="!vm.services?.length && !vm.loading && vm.isInitialized">
		<div class="c-card u-ost-md u-osb-md">
			<div class="c-content c-content--xxl">
				<item-no-content></item-no-content>
			</div>
		</div>
	</div>
</div>
